// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__35A-j","label":"styles_label__THoot"};